import { Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs';

type ErrorPayload = {
  errorId: string;
  type: 'hydra' | 'medusa';
  category: 'error';
  urlPath: string;
  payload: any;
  error: any;
  message?: string;
  sequenceId?: number;
  context: any;
};

type AlertPayload = {
  message: string;
  level: 'info' | 'warn' | 'error';
  type: 'ui';
  errorId?: string;
  category: 'error';
  payload?: any;
  error?: any;
  sequenceId?: number;
};

type AccessPayload = {
  type: 'access';
  category: 'login' | 'logout';
  sequenceId?: number;
};

type TimingPayload = {
  type: 'hydra';
  category: 'requestTiming';
  startTime: number;
  endTime: number;
  roundTripTime: number;
  flightTime: number;
  timezone: string;
  hydraTimeIn: number;
  hydraTimeOut: number;
  hydraTimeDiff: number;
  hydraLog: string;
  lambdaName: string;
  emailDomain: number;
  group: string;
  sequenceId?: number;
};

type HydraRequest = {
  type: 'hydra';
  category: 'request';
  urlPath: string;
  payload: any;
  sequenceId?: number;
};

type HydraResponse = {
  type: 'hydra';
  category: 'response';
  urlPath: string;
  response: any;
  sequenceId?: number;
};

type Payload =
  | ErrorPayload
  | AlertPayload
  | AccessPayload
  | TimingPayload
  | HydraResponse
  | HydraRequest;

@Injectable({
  providedIn: 'root'
})
/**
 * This is here to avoid a circular DI depenency.
 */
export class PhoenixEventBusService {
  public queue = new ReplaySubject<Payload>(25);
  private sequenceId = 0;

  public addEvent(event: Payload) {
    event.sequenceId = ++this.sequenceId;
    this.queue.next(event);
  }
}
